import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 10.6495V15H17.5C17.7761 15 18 15.2239 18 15.5C18 15.7762 17.7761 16 17.5 16H17H16H14.5H13.5H12.5H10H7.5H6.5H5.5H4H3H2.5C2.22386 16 2 15.7762 2 15.5C2 15.2239 2.22386 15 2.5 15H3V10.6495C3 10.1137 3.21499 9.60034 3.59679 9.22441L3.9234 8.90283C4.63433 8.20283 5.7608 8.17903 6.5 8.83141V6.48064C6.5 5.87307 6.77618 5.29845 7.25061 4.9189L8.75061 3.7189C9.48105 3.13455 10.519 3.13455 11.2494 3.7189L12.7494 4.9189C13.2238 5.29845 13.5 5.87307 13.5 6.48064V8.83141C14.2392 8.17903 15.3657 8.20283 16.0766 8.90283L16.4032 9.22441C16.785 9.60034 17 10.1137 17 10.6495ZM5 15H4V10.6495C4 10.3816 4.1075 10.1249 4.2984 9.93698L4.625 9.6154C4.7368 9.50532 4.87042 9.43073 5.01178 9.39164C5.00407 9.42653 5 9.4628 5 9.50001V15ZM6 15V9.73848L6.2016 9.93698C6.3925 10.1249 6.5 10.3816 6.5 10.6495V15H6ZM13.5 15H14V9.73848L13.7984 9.93698C13.6075 10.1249 13.5 10.3816 13.5 10.6495V15ZM15 9.50001V15H16V10.6495C16 10.3816 15.8925 10.1249 15.7016 9.93698L15.375 9.6154C15.2632 9.50532 15.1296 9.43073 14.9882 9.39164C14.9959 9.42653 15 9.4628 15 9.50001ZM7.5 15V10.6495V6.48064C7.5 6.17686 7.63809 5.88954 7.87531 5.69977L9.37531 4.49977C9.41766 4.46589 9.46209 4.43593 9.5081 4.4099C9.50278 4.43913 9.5 4.46925 9.5 4.50002V15H7.5ZM10.4919 4.4099C10.5379 4.43593 10.5823 4.46589 10.6247 4.49977L12.1247 5.69977C12.3619 5.88954 12.5 6.17686 12.5 6.48064V10.6495V15H10.5V4.50001C10.5 4.46925 10.4972 4.43913 10.4919 4.4099Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 5.13396C11.4815 5.14465 11.4633 5.15598 11.4453 5.16795L9.4453 6.50128C9.1671 6.68675 9 6.99898 9 7.33333V13.3333V19H11.5V5.13396ZM8 19V13.3333C8 12.999 7.8329 12.6867 7.5547 12.5013L7.0547 12.1679C7.03675 12.156 7.0185 12.1447 7 12.134V19H8ZM8 11.5963V7.33333C8 6.66463 8.3342 6.04016 8.8906 5.66923L10.8906 4.3359C11.2265 4.11197 11.6132 4 12 4C12.3868 4 12.7735 4.11197 13.1094 4.3359L15.1094 5.66923C15.6658 6.04016 16 6.66463 16 7.33333V8.5L16.549 8.81699C16.7882 8.95506 16.8701 9.26085 16.7321 9.5C16.594 9.73915 16.2882 9.82108 16.049 9.68301L16 9.6547V11.5963L16.3906 11.3359C16.7265 11.112 17.1132 11 17.5 11C17.8868 11 18.2735 11.112 18.6094 11.3359L19.1094 11.6692C19.6658 12.0402 20 12.6646 20 13.3333V19H21.5C21.7761 19 22 19.2239 22 19.5C22 19.7761 21.7761 20 21.5 20H17.5H12H6.5H2.5C2.22386 20 2 19.7761 2 19.5C2 19.2239 2.22386 19 2.5 19H4V13.3333C4 12.6646 4.3342 12.0402 4.8906 11.6692L5.3906 11.3359C5.7265 11.112 6.11325 11 6.5 11C6.88675 11 7.2735 11.112 7.6094 11.3359L8 11.5963ZM16 13.3333V19H17V12.134C16.9815 12.1447 16.9633 12.156 16.9453 12.1679L16.4453 12.5013C16.1671 12.6867 16 12.999 16 13.3333ZM15 7.92265L13.951 7.31699C13.7118 7.17892 13.406 7.26085 13.2679 7.5C13.1299 7.73915 13.2118 8.04494 13.451 8.18301L15 9.07735V13.3333V19H12.5V5.13396C12.5185 5.14465 12.5367 5.15598 12.5547 5.16795L14.5547 6.50128C14.8329 6.68675 15 6.99898 15 7.33333V7.92265ZM5.9453 12.1679C5.96325 12.156 5.9815 12.1447 6 12.134V19H5V13.3333C5 12.999 5.1671 12.6867 5.4453 12.5013L5.9453 12.1679ZM18 19H19V13.3333C19 12.999 18.8329 12.6867 18.5547 12.5013L18.0547 12.1679C18.0367 12.156 18.0185 12.1447 18 12.134V19Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'company');
export default IconComponent;
